import { TitleSearchFeeSettings } from '../titleSearch';
import { ClientType } from '../clients';
import { SortDirection } from '../common';

export interface ParcelInstrument {
	amount: string;
	parties_from: string[];
	parties_to: string[];
	reg_date: string;
	reg_number: string;
	status: string;
	type: string;
	sameNamesToIndexes?: number[];
	sameNamesFromIndexes?: number[];
}

export interface Owner {
	name: string;
	capacity: Record<string, string>;
	sameName?: boolean;
}

export interface Parcel {
	billable_activity_id: string;
	instruments: ParcelInstrument[];
	notes: string[];
	owners: Owner[];
	/**
	 * @deprecated DO NOT USE THIS FIELD ANYMORE - It's not being used or saved anywhere. To Be Removed
	 */
	pdf_pages_b64: string; // To Do: remove
	price: string;
	product_name: string;
	property_description: string;
	provider: string;
	subtitle: string;
	title: string;
	uploaded_document_path: string;
}

export interface Pin {
	pin: string;
	registration_type: string;
	status_ind: string;
	address: PinAddress;
	legal_desc: string;
}

export interface PinAddress {
	area: string;
	street_name: string;
	street_number: string;
	street_suffix: string;
	unit_number: string;
	unit_type: string;
}
export interface AdjacentParcel {
	pin: string;
	lro: string;
	distance: string;
	type: string;
	address: PinAddress;
	registration_type: string;
	status_ind: string;
	legal_desc: string;
}

export interface MapLegend {
	type: string;
	blue: string;
	green: string;
	red: string;
	layer: string;
}

export interface SavedMap {
	product_name: string;
	price: string;
	map_state: string;
	adjacent_parcels: AdjacentParcel[];
	encoded_map: string; // To Do: To be removed
	legends: MapLegend[];
	scale_distance: string;
	scale_pixels: string;
	disclaimer: string;
	uploaded_document_path: string;
}

export interface SavedParcel {
	billable_activity_id: string;
	latestInstrumentNumber: string;
	instruments: ParcelInstrument[];
	notes: string[];
	owners: Owner[];
	price: string;
	product_name: string;
	property_description: string;
	provider: string;
	subtitle: string;
	title: string;
	dateSearched: number;
	/**
	 * @deprecated DO NOT USE THIS FIELD ANYMORE - It's not being used or saved anywhere. To Be Removed
	 */
	pdf_pages_b64?: string; // To Do: To be Removed
	uploaded_document_path: string;
}

export interface SavedPin extends Pin {
	id?: string;
	parent: boolean;
	primary: boolean;
	lastUpdated: number;
	parcels: SavedParcel[];
	map?: SavedMap;
	partLot: boolean;
	sameAdjacentOwners: boolean;
	synced: boolean;
}

export interface WritCertificate {
	type: string;
	request_date: string;
	image: string;
	number: string;
}

export interface WritName {
	execution_number: string;
	first_name: string;
	last_name: string;
	execution?: WritExecution;
}

export interface ExecutionSolicitor {
	Address: string;
	Aggregatefield: string;
	Eoffice: string;
	Filenumber: string;
	Firmname: string;
	Givenname: string;
	Recordtype: string;
	Sameascreditorind: string;
	Solicitorid: string;
	Surname: string;
}

export interface ExecutionDefendant {
	Address: string;
	AggregateAddress: string;
	AggregateName: string;
	City: string;
	Country: string;
	DefendantID: string;
	Email: string;
	Eofficeid: string;
	Fax: string;
	FileNumber: string;
	Names: string;
	PostalCode: string;
	Province: string;
	RecordType: string;
	Telephone: string;
}

export interface ExecutionDebtor {
	Companyname: string;
	Dateofbirth: string;
	Debtor: string;
	Eofficeid: string;
	Extdebtorid: string;
	Filenumber: string;
	Firstname: string;
	Surname: string;
	Type: string;
}

export interface ExecutionCreditor {
	Address: string;
	AggregateField: string;
	City: string;
	CompanyName: string;
	Country: string;
	CreditorID: string;
	CreditorType: string;
	EOfficeId: string;
	Email: string;
	Fax: string;
	FileNumber: string;
	Firstname: string;
	Lastname: string;
	PostalCode: string;
	Province: string;
	RecordType: string;
	Telephone: string;
}

export interface ExecutionSummary {
	Actionnumber: string;
	Addstatutoryfeeind: string;
	Applicationname: string;
	Assignmentdate: string;
	Bankruptcywithdrawalind: string;
	Blockedind: string;
	Canexpireind: string;
	Careofsolicitorind: string;
	Courttype: string;
	Createdate: string;
	Createdbyrefileind: string;
	Declaredate: string;
	Declarereceivedind: string;
	Deletedate: string;
	Effectivedate: string;
	Enforcementoffice: string;
	Expirationdate: string;
	Filedbyfroind: string;
	Filedinlandtitlesind: string;
	Filenumprefix: string;
	Filenumsearchsuffix: string;
	Filenumsuffix: string;
	Garnishnumber: string;
	Inactivedate: string;
	Inactivereason: string;
	Issuedate: string;
	Location: string;
	Newfilenum: string;
	Oldfilenum: string;
	Postdate: string;
	Priority: string;
	Remoteupdateappid: string;
	Remoteupdatefunctionid: string;
	Schemanumber: string;
	Storejudgmentinfoind: string;
	Supportwritind: string;
	Writstatus: string;
	Writtype: string;
}

export interface JudgementInfo {
	Eofficeid: string;
	Costamount: number;
	Costcurrency: string;
	Costinterestrate: number;
	Judgmentamount: number;
	Judgmentinfoid: string;
	Judgmentcurrency: string;
	Judgmentinterestrate: number;
	Filenumber: string;
	Startdatecostinterest: string;
	Startdatejudgementinterest: string;
}

export interface WritExecution {
	certificate: WritCertificate;
	creditors: ExecutionCreditor[];
	debtors: ExecutionDebtor[];
	defendants: ExecutionDefendant[];
	solicitors: ExecutionSolicitor[];
	summary: object;
	judgment_infos: JudgementInfo[];
	price: string;
	product_name: string;
	public_comments: string;
	writ_format_id: string;
	lock_version: string;
}

export interface Writ {
	certificate: WritCertificate;
	price: string;
	product_name: string;
	names: { [id: string]: WritName };
}

export interface WritEntity {
	id?: string;
	type?: ClientType;
}

export interface Company extends WritEntity {
	name: string;
}

export interface Person extends WritEntity {
	firstName: string;
	lastName: string;
}

export interface Execution extends WritEntity {
	number: string;
}

export enum WritSearchType {
	PERSON = 'person',
	COMPANY = 'company',
	EXECUTION = 'execution',
}

export type WritSearchItemItem = Company | Person | Execution;

export interface WritSearchItem {
	type: WritSearchType;
	item: WritSearchItemItem;
}

export enum WritSearchStatus {
	SEARCHING = 'searching',
	SUCCESS = 'success',
	FAILED = 'failed',
}

export interface SavedWrit {
	id: string;
	search: WritSearchItem;
	writ?: Writ;
	status: WritSearchStatus;
	error?: string;
}

export interface InstrumentSearch {
	lro: string;
	registration_number: string;
	document_type: string;
	document_format: string;
	document_number: string;
	number_of_pages: string;
	document_size: string;
	is_plan: string;
}

export interface InstrumentDocument {
	filename: string;
	file_content: string;
}

export interface InstrumentAttachment {
	document_number: string;
	document_format: string;
	document_type: string;
	document_name: string;
	registration_number: string;
	number_of_pages: string;
	plan: string;
	price_total?: string;
	uploaded_document_path?: string;
	lro: string;
}

export interface InstrumentSorting {
	field?: string;
	direction?: SortDirection;
}

export interface TeranetInstruments {
	sorting?: InstrumentSorting;
}

export interface TeranetUserSettings {
	instruments?: TeranetInstruments;
}

export interface SavedInstrument {
	id?: string;
	product_name: string;
	price_total?: string;
	plan?: string;
	document_format?: string;
	instrument_number: string;
	registration_number?: string;
	document_number: string;
	requisitioned?: boolean;
	encumbranceId?: string;
	document_name?: string;
	uploaded_document_path?: string;
	number_of_pages: string;
	lro: string;
	attachments: Record<string, InstrumentAttachment>;
	pin: string;
}

export interface TeranetCredentials {
	accountName: string;
	username: string;
	password: string;
}

export interface TeranetAccounts {
	accounts: Record<string, TeranetAccount>;
}

export interface TeranetAccount {
	creditBalance: number;
	officeId: number;
	officeName: string;
	usernames: Record<string, TeranetUser>;
}

export interface TeranetUser {
	password: string;
	verifiedUsers: string[];
}

export interface SearchPropertyOwners {
	names: SearchPropertyOwner[];
}

export interface SearchPropertyOwner {
	first_name: string;
	last_name: string;
}

export interface DocketSearchResponse {
	docket_search_details: DocketSearchDetail[];
}

export interface DocketSearchDetail {
	docket_id: string;
	docket_name: string;
	docket_status: 'y' | 'n';
	docket_system_id: string;
}

export interface PinsResult {
	pin_infos: Pin[];
}

export interface DocumentSearchResponse {
	lro: string;
	registration_number: string;
	document_type: string;
	document_format: string;
	document_number: string;
	number_of_pages: string;
	document_size: string;
	is_plan: string;
}

export interface DocumentDownloadResponse {
	product_name: string;
	price_total: string;
	plan: string;
	file_format: string;
	document: Document;
	uploaded_document_path: string;
}

export interface Document {
	filename: string;
	file_content: string;
}

export interface UpsertUserToTeranetAccountInputData {
	account: string;
	username: string;
	password: string;
	userId: string;
}

export interface DocketChargeItem {
	amount: string;
	description: string;
	hst_amount: string;
	session_id: string;
	session_start_time: string;
	user_login_name: string;
}

export interface ViewDocketChargeItem {
	amount_hst_appl: number;
	amount_hst_not_appl: number;
	amount: number;
	description: string;
	hst_amount: number;
	session_id: string;
	session_start_time: string;
	user_login_name: string;
}

export interface DocketSummaries {
	parcel: DocketSummary;
	writs: DocketSummary;
	total_hst_appl: number;
	total_hst_not_appl: number;
	total_hst: number;
	total: number;
}

export interface DocketSummary {
	items: ViewDocketChargeItem[];
	total_hst_appl: number;
	total_hst_not_appl: number;
	total_hst: number;
	total: number;
}

export interface IDocketSummaryParams {
	createdAt: number;
	docket_system_id: string;
	/**
	 * The HST rate for the matter as a decimal (dollar amount)
	 * @example 0.13
	 * @type {number}
	 */
	matterHST: number;
	feeSettings?: TitleSearchFeeSettings;
}

export interface TeranetErrorDetails {
	code: string;
	error: string;
	message: string;
}

export interface TeranetErrorResponse {
	details: TeranetErrorDetails;
	message: string;
	status: string;
	isUserError: boolean;
}

export interface TeranetHttpError {
	error: TeranetErrorResponse;
}
